/**
 * TPM PUBLIC API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Brand } from './brand';
import { ExistingInitialConsultation } from './existingInitialConsultation';


/**
 * A booking link; without a resource of its own the patient is offered every bookable therapist.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface BookingLink { 
    brand: Brand | null;
    appointmentTypeName: string;
    appointmentLength: number;
    appointmentFormatInfo: string;
    appointmentFormatIcon: string;
    appointmentResourceName: string;
    appointmentResourcePinned: boolean;
    appointmentResourceNamePrefix: string;
    cancellationPeriodInHours: number;
    existingInitialConsultation: ExistingInitialConsultation | null;
}
export const BookingLink_brand_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingLink_appointmentTypeName_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingLink_appointmentLength_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingLink_appointmentFormatInfo_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingLink_appointmentFormatIcon_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingLink_appointmentResourceName_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingLink_appointmentResourcePinned_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingLink_appointmentResourceNamePrefix_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingLink_cancellationPeriodInHours_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingLink_existingInitialConsultation_Validators: ValidatorFn[] =
    [  Validators.required, ];


